import * as React from 'react';
import classnames from 'classnames';
/**
 *
 *
 * <Table.Header>
 *  <div>订单号: 12312312</div>
 *  <div>拣选号： 123092103129 | 蓝号 01</div>
 * </Table.Header>
 *
 */
export default function Title(props) {
    const { className = '', children } = props;
    return (React.createElement("div", { className: classnames('op-table-title', className) }, children));
}
